import { Box, Button, Heading, Text } from '@chakra-ui/react';
import getConfig from 'next/config';
import { usePackContext } from "./context";
import { isReadOnly } from "lib/utils";
import { usePack, useStickyAd } from 'lib/hooks';
import { config } from 'lib';
import { WavingHand } from 'lib/icons';

const { publicRuntimeConfig: { genericSubDomain, baseProtocol, baseDomain, basePort }} = getConfig();

export const Ad = () => {
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);
  const { setHideAd } = useStickyAd(packId);

  return (
    <Box position="fixed" left={0} right={0} bottom={0} paddingBottom={5} height={[235, 200, 175, 125]} pb={0} zIndex={100} bgColor={isReadOnly ? 'transparent' : 'white'}>
      <Box
        borderRadius={15}
        marginTop="15px"
        boxShadow={isReadOnly(pack) ? "1px 0px 5px rgba(0, 0, 0, 0.16)" : 'none'}
        padding="10px"
        bottom={10}
        backgroundColor="white"
        maxWidth={960}
        margin="0 auto"
      >
        <Box
          borderColor="brand.500"
          borderWidth="2px"
          borderStyle="solid"
          borderRadius={15}
          padding={['5px 15px', '5px 15px', '5px 15px', '15px']}
          display="flex"
          gridGap="10px"
          flexDirection={['column', 'column', 'column', 'row']}
          alignItems="center"
          backgroundColor="white"
        >
          <Box gridGap="10px" alignItems="center" display="flex" minHeight={['45px', '0px']}>
            <Box>
              <WavingHand fontSize={['3xl', '3xl', '3xl', '5xl']} />
            </Box>
            <Heading
              fontSize={['lg', 'xl', 'xl', '2xl']}
              fontWeight="bold"
            >
              This is your workmate&apos;s pack.
            </Heading>
          </Box>
          <Text minHeight={['70px', '50px', '0px']} fontSize="md" textAlign={['center', 'center', 'center', 'left']}>
            Keep your own links, files, videos &amp; text together in neat packs too. Then share them.
          </Text>
          <Box display="flex" justifyContent="center" flexDirection="column" gridGap="10px" className="heap-open-sticky-ad">
            <Button variant="primary" onClick={() => window.open(`${baseProtocol}://${genericSubDomain}${baseDomain}${basePort}/register?referrer=${config.ad.singlePack.param}`, '_blank')}>Get Packs</Button>
            <Button variant="link" onClick={() => setHideAd(true)} fontStyle="italic" fontWeight="medium" className="heap-close-sticky-ad">No thanks!</Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
